export default {
    jwt: v => v.jwt,
    responseMsg: v => v.responseMsg,
    error: v => v.error,
    isLoading1: v => v.isLoading1,
    isLoading2: v => v.isLoading2,
    user: v => v.user,
    guestUser: v => v.guestUser,
    users: v => v.users,
    searchedUsers: v => v.searchedUsers,
    broadcast: v => v.broadcast,
    broadcast_group: v => v.broadcast_group,
    broadcast_groups: v => v.broadcast_groups,
    broadcasts: v => v.broadcasts,
    apiDomain: v => v.apiDomain,
    table: v => v.table,
    tables: v => v.tables || [],
}
